export const baseURL = "https://casino.rigolive.com/";
export const adminBaseURL = "https://admin.rigolive.com/";
export const key = "?SOaT3E25QRvvy=B_|R5XrLxFf)hY+4r";